"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _dist = require("@low6dev/react-utils/dist");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  margin-right: 0.5rem;\n  display: flex;\n  padding-left: 0.875rem;\n  align-items: center;\n  justify-content: flex-start;\n  height: 58px;\n  border-radius: ", ";\n\n  background: ", ";\n"])), function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.colorLightGrey;
});

var StyledPopularLabel = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 0.75rem;\n  margin-bottom: 0.3rem;\n  color: ", ";\n"])), function (p) {
  return p.theme.colorLabel;
});

var StyledPopularValue = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 1rem;\n"])));

var StyledIconWrapper = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n  border-radius: ", ";\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (p) {
  return p.hasIcon ? "transparent" : p.isLightPrimary ? p.theme.colorAccent : p.theme.colorPrimary;
}, function (p) {
  return p.hasIcon ? "transparent" : p.isLightPrimary ? p.theme.colorAccentText : p.theme.colorPrimaryText;
}, function (p) {
  return p.hasIcon ? 0 : "50%";
});

var StyledIcon = _styledComponents.default.img(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 40px;\n  height: 40px;\n"])));

var ContestPicksPopular = function ContestPicksPopular(_ref) {
  var popularSelection = _ref.popularSelection;
  var iconUrl = process.env.REACT_APP_POPULAR_PICK_ICON;

  if (iconUrl) {
    iconUrl = (0, _dist.createImageCdnLink)(iconUrl);
  }

  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.contest;
  }),
      translations = _useSelector.translations;

  var isLightPrimary = process.env.REACT_APP_COLOR_PRIMARY_IS_LIGHT;
  console.log("popularSelection", popularSelection); // apply translations to yes/no

  popularSelection = popularSelection.replace("Yes", translations.yes);
  popularSelection = popularSelection.replace("No", translations.no);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIconWrapper, {
      isLightPrimary: isLightPrimary,
      hasIcon: iconUrl,
      children: iconUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIcon, {
        src: iconUrl
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.MatIcon, {
        children: "groups"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        marginLeft: "0.75rem"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledPopularLabel, {
        children: process.env.REACT_APP_POPULAR_PICK_TITLE || translations.popularPick
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledPopularValue, {
        children: popularSelection || "-"
      })]
    })]
  });
};

var _default = ContestPicksPopular;
exports.default = _default;